import {gql} from '@apollo/client';

export default gql`
  mutation deletePodcasts($input: DeletePodcastsInput!) {
    authed {
      success
    }
    deletePodcasts(input: $input) {
      success
    }
  }
`;
